/**
 * Swak Custom - Free Shipping Bar Controller
 * 送料無料ライン表示の集約コントローラー
 * 全表示箇所を一括管理し、カート更新時に動的に更新
 */

class SwakFreeShippingController {
  constructor() {
    this.threshold = 0;
    this.messageBefore = '';
    this.messageAfter = '';
    this.messageEmpty = '';
    this.initRetryCount = 0;
    this.maxRetries = 10;
    this.init();
  }

  /**
   * 初期化
   */
  init() {
    const firstBar = document.querySelector('[data-swak-location]');
    if (!firstBar) {
      this.initRetryCount++;
      if (this.initRetryCount < this.maxRetries) {
        setTimeout(() => this.init(), 100);
      }
      return;
    }

    this.threshold = parseInt(firstBar.dataset.swakThreshold) || 0;
    this.messageBefore = firstBar.dataset.swakMessageBefore || 'あと{amount}で送料無料！';
    this.messageAfter = firstBar.dataset.swakMessageAfter || '送料無料でお届けします！';
    this.messageEmpty = firstBar.dataset.swakMessageEmpty || '';

    this.fetchAndUpdateCart();

    document.addEventListener('swak:cart:updated', this.handleCartUpdate.bind(this));
    document.addEventListener('cart:update', this.handleCartUpdate.bind(this));
  }

  /**
   * カート情報を取得して全バーを更新
   */
  async fetchAndUpdateCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const cartTotal = (cart.total_price || 0) / 100;
      const itemCount = cart.item_count || 0;
      this.updateAllBars(cartTotal, itemCount);
    } catch (error) {
      console.error('[Swak] カート情報の取得に失敗:', error);
    }
  }

  /**
   * カート更新イベントハンドラ
   * @param {CustomEvent} event - カート更新イベント
   */
  handleCartUpdate(event) {
    const cart = event.detail?.cart || event.detail?.resource;
    if (!cart) return;

    const cartTotal = (cart.total_price || 0) / 100;
    const itemCount = cart.item_count || 0;

    this.updateAllBars(cartTotal, itemCount);
  }

  /**
   * すべての送料無料バーを更新
   * @param {number} cartTotal - カート合計金額（円）
   * @param {number} itemCount - カート商品数
   */
  updateAllBars(cartTotal, itemCount = 0) {
    const bars = document.querySelectorAll('[data-swak-location]');

    bars.forEach(bar => {
      this.updateBar(bar, cartTotal, itemCount);
    });
  }

  /**
   * 個別の送料無料バーを更新
   * @param {HTMLElement} bar - 更新対象のバー要素
   * @param {number} cartTotal - カート合計金額（円）
   * @param {number} itemCount - カート商品数
   */
  updateBar(bar, cartTotal, itemCount = 0) {
    const messageElement = bar.querySelector('[data-swak-message]');
    const progressBar = bar.querySelector('[data-swak-progress-bar]');

    if (!messageElement && !progressBar) return;

    if (itemCount === 0) {
      if (messageElement) {
        if (this.messageEmpty) {
          const thresholdFormatted = this.formatMoney(this.threshold);
          const message = this.messageEmpty.replace('{amount}', thresholdFormatted);
          messageElement.textContent = message;
          messageElement.style.display = '';
        } else {
          // messageEmptyが空の場合は非表示
          messageElement.textContent = '';
          messageElement.style.display = 'none';
        }
      }
      if (progressBar) {
        progressBar.style.width = '0%';
      }
      return;
    }

    const remaining = Math.max(0, this.threshold - cartTotal);
    const progressPercentage = this.threshold > 0
      ? Math.min(100, (cartTotal / this.threshold) * 100)
      : 0;

    let message;
    if (cartTotal >= this.threshold) {
      message = this.messageAfter;
    } else {
      const remainingFormatted = this.formatMoney(remaining);
      message = this.messageBefore.replace('{amount}', remainingFormatted);
    }

    if (messageElement) {
      messageElement.textContent = message;
      messageElement.style.display = '';
    }
    if (progressBar) {
      progressBar.style.width = `${progressPercentage}%`;
    }
  }

  /**
   * 金額をフォーマット
   * @param {number} amount - 金額（円）
   * @returns {string} フォーマットされた金額文字列
   */
  formatMoney(amount) {
    return `¥${Math.round(amount).toLocaleString('ja-JP')}`;
  }
}

if (typeof window !== 'undefined') {
  if (window.swakFreeShipping) {
  } else {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        if (!window.swakFreeShipping) {
          window.swakFreeShipping = new SwakFreeShippingController();
        }
      });
    } else {
      window.swakFreeShipping = new SwakFreeShippingController();
    }
  }
}

export default SwakFreeShippingController;